import { render } from "./CustomCalendar.vue?vue&type=template&id=5ba565ca&scoped=true"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"

import "./CustomCalendar.vue?vue&type=style&index=0&id=5ba565ca&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba565ca"]])

export default __exports__